export enum AccessHistoryType {
  'VIEW' = 'VIEW',
  'DOWNLOAD' = 'DOWNLOAD',
}

export enum AccessHistoryUserType {
  'USER' = 'USER',
  'CONTACT' = 'CONTACT',
}
